import Vue from "vue";
import VueRouter from "vue-router";
import middleware from './middleware'
import store from "../store"
import jwtDecode from '../utils/jwt_decode'

Vue.use(VueRouter);

const routes = [
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/exchangeControl",
    name: "ExchangeControl",
    component: () => import("../views/ExchangeControl.vue"),
  },
  {
    path: "/formOfPayment",
    name: "formOfPayment",
    component: () => import("../views/Formofpayments.vue"),
  },
  {
    path: "/paymentTerms",
    name: "PaymentTerms",
    component: () => import("../views/Paymentterm.vue"),
  },
  {
    path: "/cashier",
    name: "Cashier",
    component: () => import("../views/Cashier.vue"),
  },
  {
    path: "/ProductGroup",
    name: "ProductGroup",
    component: () => import("../views/ProductGroup.vue"),
  },
  {
    path: "/users",
    name: "User",
    component: () => import("../views/User.vue"),
  },
  {
    path: "/client",
    name: "Client",
    component: () => import("../views/Client.vue"),
  },
  {
    path: "/produtos",
    name: "Product",
    component: () => import("../views/Product.vue"),
  },
  {
    path: "/seller",
    name: "Seller",
    component: () => import("../views/Seller.vue"),
  },
  {
    path: "/transport",
    name: "Transport",
    component: () => import("../views/Transporter.vue"),
  },
  {
    path: "/Sales",
    name: "Sales",
    component: () => import("../views/Sales.vue"),
  },
  {
    path: "/notes",
    name: "Notes",
    component: () => import("../views/Notes.vue"),
  },
  {
    path: "/parameter",
    name: "Parameter",
    component: () => import("../views/Parameter.vue"),
  },
  {
    path: "/checkcashier",
    name: "ChechCashier",
    component: () => import("../views/Checkcashier.vue"),
  },
  {
    path: "/enterprise",
    name: "Enterprise",
    component: () => import("../views/Enterprise.vue"),
  },
  {
    path: "/permission",
    name: "Permission",
    component: () => import("../views/Permission.vue"),
  },
  {
    path: "/",
    name: "Login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/shortcuts",
    name: "Shortcuts",
    component: () => import("../views/Shortcuts"),
  },
  {
    path: "/contingency",
    name: "Contingency",
    component: () => import("../views/Contingency.vue"),
  },
  {
    path: "/checkcashierslip",
    name: "CheckCashierSlip",
    component: () => import("../views/Reports/close_cashier"),
  },
  {
    path: "/budget",
    name: "Budget",
    component: () => import("../views/Budget.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, _, next) => {
  const storagedToken = localStorage.getItem('token');
  const storagedFiscal = localStorage.getItem('token_fiscal');
  const storagedTokenGestao = localStorage.getItem('token_gestao');

  if (!jwtDecode(storagedToken) || !jwtDecode(storagedFiscal) ||!jwtDecode(storagedTokenGestao
    )) {
      localStorage.removeItem("authenticated");
      localStorage.removeItem('token')
      localStorage.removeItem('token_fiscal')
      localStorage.removeItem('token_gestao')
  }
  if (to.name !== "Login") {
    let auth = JSON.parse(localStorage.getItem("authenticated"));
    
    if (storagedToken == null ||storagedFiscal ==null ||storagedTokenGestao ==null ){
      store.commit("auth/SET_USER");
      store.commit("auth/SET_ISVALID", false);
      return next({
        name: "Login",
      })
    }
    if (!auth) {
      store.commit("auth/SET_USER");
      store.commit("auth/SET_ISVALID", false);
      return next({
        name: "Login",
      });
    } else {
      store.commit("auth/SET_USER", auth);
      store.commit("auth/SET_ISVALID", true);

    }
  } else if (to.name === "Login") {
    let auth = JSON.parse(localStorage.getItem("authenticated"));
    if (auth) {
      store.commit("auth/SET_USER", auth);
      return next({
        name: 'Shortcuts'
      });
    }
  }
  next();
});
middleware(router)


export default router;
